<div class="radioContainer row">
  <app-radio
    [attribute]="getRadioElement()"
    [class]="getSizeClass(getRadioElement())"
    [envOptions]="envOptions"
    (onEmit)="onChangedSelect($event)">
  </app-radio>

  <app-dynamic *ngFor="let contentItem of selectedContentAttrs" 
      [class]="getSizeClass(contentItem)" 
      [attribute]="contentItem"
      [envOptions]="envOptions" 
      [parent]="attribute"
      (onEmit)="handleEvent($event)">
  </app-dynamic>
</div>
